
@if (isAgainstRecommendation && !showGuidedSv) {
  <!-- Against Recommendation Screen -->
  <div class="flex-modal-wrapper">
    <div class="modal-row">
      <p>Bifocal or Progressive lenses may be needed to correct for both distance and near vision.
      If you order single vision lenses, they will correct for distance vision only and not for reading.</p>
      <h5>Are you sure you want <span class="text-blue">Single Vision Distance Only</span> lenses ?</h5>
    </div>
    <div class="modal-row">
      <div class="modal-col">
        <p>Single Vision</p>
        <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
        <button type="button" class="btn gray-btn" (click)="onAcceptedWarning()">Yes</button>
      </div>
      <div class="modal-col">
        <p>Bifocal/Progressive</p>
        <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
        <button type="button" class="btn gray-btn" (click)="showBifocalProgressive()">No</button>
      </div>
    </div>
  </div>
  <!-- Against Recommendation Screen -->
} @else {
  @if (lowerGradeSVOption && higherGradeSVOption) {
    <!-- Single Vision Selection Screen -->
    <div class="modal-row">
      <h5>Please select a Single Vision lens</h5>
      <img src="../../../../assets/images/guided-opt/single-vision-lenses.png" class="sv-full">
    </div>
    <div class="modal-row">
      <div class="modal-col">
        <img src="../../../../assets/images/guided-opt/svBasic.png" class="sv-basic">
        <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
        <span>{{lowerGradeSVOption.lensName}}</span>
        <button type="button" class="btn gray-btn" (click)="selectLens(lowerGradeSVOption)">
          +{{lowerGradeSVOption.price | currency}}
        </button>
      </div>
      <div class="modal-col">
        <img src="../../../../assets/images/guided-opt/svUltimate.png" class="sv-ultimate">
        <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
        <span>{{higherGradeSVOption.lensName}}</span>
        <button type="button" class="btn gray-btn" (click)="selectLens(higherGradeSVOption)">
          +{{higherGradeSVOption.price | currency}}
        </button>
      </div>
    </div>
    <!-- Single Vision Selection Screen -->
  }
}

